import { useEffect } from 'react';

export default function useExitOfferModal({
  triggeredModal,
  setTriggeredModal,
  shouldShowModal,
  authenticated,
  dispatch,
  toggleBundleExitOfferModal,
}) {
  useEffect(() => {
    const handleMouseMove = (e) => {
      const navElement = document.querySelector('.navbar');
      if (!navElement) return;
      const navRect = navElement.getBoundingClientRect();
      const isInNavArea = e.clientY <= navRect.bottom;
      if (isInNavArea && !triggeredModal && shouldShowModal && authenticated) {
        setTriggeredModal(true);
      }
    };

    const handleMouseLeave = (e) => {
      if (e.clientY <= 0 && !triggeredModal && shouldShowModal && authenticated) {
        setTriggeredModal(true);
      }
    };

    document.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseleave', handleMouseLeave);

    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseleave', handleMouseLeave);
    };
  }, [triggeredModal, shouldShowModal, authenticated, setTriggeredModal]);

  useEffect(() => {
    if (triggeredModal) {
      dispatch(toggleBundleExitOfferModal());
    }
  }, [triggeredModal, dispatch, toggleBundleExitOfferModal]);
}
